import { useTranslation } from 'react-i18next'
import { Box, Alert } from '@mui/material'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import PageContainer from '@/components/ui/containers/PageContainer'
import { EstablishmentPlanningsDashboard } from '@/features/plannings-dashboard'
import { EstablishmentPlanningsManagement } from '@/features/plannings-management'
import { PlanningsTabEnum, PlanningsTabs, usePlanningsTab } from '@/shared/plannings'

export function AdminPlanningsPage() {
  const { t } = useTranslation()
  const authUser = useAppSelector(selectAuthUser)
  const tab = usePlanningsTab()

  const establishment = authUser?.establishment

  // Check if the user has an establishment
  if (!authUser || !establishment) {
    return (
      <PageContainer>
        <Alert severity="warning">
          {t('page.admin.plannings.noEstablishment', { defaultValue: 'You need to be associated with an establishment to manage plannings.' })}
        </Alert>
      </PageContainer>
    )
  }

  return (
    <PageContainer>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <PlanningsTabs />
        </Box>
        {tab === PlanningsTabEnum.DASHBOARD && <EstablishmentPlanningsDashboard establishmentId={establishment._id} />}
        {tab === PlanningsTabEnum.ADMIN && <EstablishmentPlanningsManagement establishmentId={establishment._id} />}
      </Box>
    </PageContainer>
  )
}

export default AdminPlanningsPage
